export default "__VITE_ASSET__mbLSKXFi__"